import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styled, { keyframes } from 'styled-components';

// 定义动画关键帧
const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// 样式化组件
const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 40px;
  animation: ${fadeIn} 0.5s ease-out;
`;

const LoadingIcon = styled.div`
  font-size: 48px;
  color: var(--primary-color);
  margin-bottom: 16px;
  animation: ${rotate} 1.5s linear infinite;
`;

const LoadingText = styled.div`
  font-size: 16px;
  color: #666;
  font-weight: 500;
  animation: ${pulse} 2s ease-in-out infinite;
  margin-top: 8px;
`;

const LoadingDots = styled.div`
  display: flex;
  gap: 4px;
  margin-top: 12px;
  
  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: var(--primary-color);
    animation: ${pulse} 1.4s ease-in-out infinite;
    
    &:nth-child(1) {
      animation-delay: 0s;
    }
    
    &:nth-child(2) {
      animation-delay: 0.2s;
    }
    
    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
`;

const LoadingSpinner = ({ 
  text = "系统初始化中...", 
  size = "large", 
  showDots = true,
  style = {} 
}) => {
  const antIcon = (
    <LoadingOutlined 
      style={{ 
        fontSize: size === 'large' ? 48 : size === 'small' ? 24 : 36,
        color: 'var(--primary-color)'
      }} 
      spin 
    />
  );

  return (
    <LoadingContainer style={style}>
      <LoadingIcon>
        <Spin indicator={antIcon} />
      </LoadingIcon>
      
      <LoadingText>{text}</LoadingText>
      
      {showDots && (
        <LoadingDots>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </LoadingDots>
      )}
    </LoadingContainer>
  );
};

export default LoadingSpinner;